import {
  Alert,
  Button,
  FileDrop,
  Grid,
  Heading,
  IconImportLine,
  IconModuleLine,
  Link,
  Modal,
  Text,
  View,
} from "@instructure/ui";
import { t } from "i18next";
import React, { useState } from "react";
// import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import {
  ERROR,
  useNotification,
} from "../components/CustomHooks/NotificationProvider";
import { Files } from "../services/FilesService";

export default function LearningTaxonomy() {
  const showNotification = useNotification();
  const [uploadDialog, setUploadDialog] = useState(false);
  const [DemographicsFile, setDemographicsFile] = useState(null);
  const [uploadError, setUploadError] = useState(false);
  // const [lastModified, setLastModified] = useState("11/14/2022, 3:07:07 PM");

  const DEMOGRAPHICS_FILE_TYPE = "demographics";

  const handleUploadClick = () => {
    setUploadDialog(true);
  };

  const handleCancel = () => {
    setUploadDialog(false);
    setDemographicsFile(null);
    setUploadError(false);
  };

  const handleSubmit = () => {
    setUploadError(false);
    if (DemographicsFile) {
      Files.saveFile(DemographicsFile, DEMOGRAPHICS_FILE_TYPE)
        .then(() => {
          setUploadDialog(false);
          setDemographicsFile(null);
          showNotification(t("notifications.demographics.uploadSuccess"));
        })
        .catch(() => {
          setUploadError(true);
        });
    }
  };

  return (
    <div>
      <Heading as="h2" level="h3" border="bottom">
        {t("demographics.headingDemographicsUpload")}
      </Heading>
      <div style={{ margin: "15px 0" }}>
        <Text as="div" lineHeight="double">
          {t("demographics.demographicsCopyLine1")}
        </Text>
        <Text as="div" lineHeight="double">
          {t("demographics.demographicsCopyLine2")}
        </Text>
        <Text as="div" lineHeight="double" weight="bold">
          {t("demographics.demographicsCopyLine3")}
        </Text>
        <Text as="div" lineHeight="double">
          <Link href="/studentDemographics.csv" target="_blank">
            {t("global.downloadExampleFile")}
          </Link>
        </Text>
      </div>
      {/* <Text lineHeight="doubled" weight="bold">
        Last modified:
      </Text>{" "}
      {lastModified} */}
      <Button
        margin="small 0"
        id="upload-demographics-button"
        color="primary"
        renderIcon={IconImportLine}
        onClick={handleUploadClick}
      >
        {t("demographics.uploadButton")}
      </Button>
      <Modal open={uploadDialog} label={t("global.dragFile")}>
        <Modal.Header>
          <Heading level="h2" as="h2">
            {t("demographics.demographicsUpload")}
          </Heading>
        </Modal.Header>
        <Modal.Body>
          <FileDrop
            accept=".csv"
            onDropAccepted={([file]) => {
              setDemographicsFile(file);
            }}
            onDropRejected={([file]) => {
              showNotification(
                t("notifications.fileRejected", { file: file.name }),
                ERROR
              );
            }}
            renderLabel={
              <View as="div" padding="xx-large large" background="primary">
                <IconModuleLine size="large" />
                <Heading>{t("demographics.dropFileHeading")}</Heading>
                <Grid>
                  <Grid.Row hAlign="center">
                    <Grid.Col>
                      <Text color="brand">
                        {t("demographics.dragAndDropLabel")}
                      </Text>
                    </Grid.Col>
                  </Grid.Row>
                  <Grid.Row hAlign="center">
                    <Grid.Col>
                      {DemographicsFile && <Text>{DemographicsFile.name}</Text>}
                    </Grid.Col>
                  </Grid.Row>
                </Grid>
              </View>
            }
          />
          {uploadError && (
            <Alert
              variant="error"
              renderCloseButtonLabel={t("global.close")}
              margin="small"
            >
              {t("learningOutcomes.uploadError")}
            </Alert>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button margin="0 small 0 0" onClick={handleCancel}>
            {t("global.cancel")}
          </Button>
          <Button onClick={handleSubmit} disabled={!DemographicsFile}>
            {t("global.submit")}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}
